import { InjectionToken } from '@angular/core';
import { type Observable } from 'rxjs';

import { type DataProviderQuery, type InputDataPackage } from '../io-data.models';

export interface InputDataStreamProvider {
  getInputDataStream(query: DataProviderQuery): Observable<InputDataPackage>;
}

export const INPUT_DATA_STREAM = new InjectionToken<InputDataStreamProvider>('InputDataStream');
